import { render } from "./CdaPage.vue?vue&type=template&id=85537c0e"
import script from "./CdaPage.vue?vue&type=script&lang=js"
export * from "./CdaPage.vue?vue&type=script&lang=js"

import "./CdaPage.vue?vue&type=style&index=0&id=85537c0e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__